import { useEffect, useState } from 'react';
import peticion from '../../../../../Api/roleList';

const useRoles = setIsLoading => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      peticion().then(data => {
        setRoles(data.roles);
        setIsLoading(false);
      });
    }

    return () => {
      isMounted = false;
      setRoles([]);
      setIsLoading(true);
    };
  }, []);

  return {
    roles,
  };
};

export default useRoles;
